(() => {
  const selector = '[data-rr-workshop-proof]';

  if (window.RRWorkshopProof) return;

  const controllers = new WeakMap();

  const getRoots = (scope) => {
    const roots = [];
    if (scope instanceof Element && scope.matches(selector)) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(selector));
    return roots;
  };

  const init = (root) => {
    if (root.dataset.rrWorkshopProofReady === 'true') return;
    root.dataset.rrWorkshopProofReady = 'true';

    const video = root.querySelector('[data-rr-workshop-proof-video]');
    const toggle = root.querySelector('[data-rr-workshop-proof-video-toggle]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealEnabled = root.dataset.motionEnabled === 'true' && !reduceMotion;
    const autoplayEnabled = root.dataset.videoAutoplay === 'true' && !reduceMotion;
    let shouldResume = autoplayEnabled;

    if (revealEnabled) root.classList.add('is-motion-ready');
    else root.classList.add('is-visible');

    const updateToggle = () => {
      if (!video || !toggle) return;
      const paused = video.paused;
      toggle.dataset.state = paused ? 'paused' : 'playing';
      toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
    };

    const playVideo = () => {
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      const promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(updateToggle);
    };

    if (video) {
      video.muted = true;
      video.playsInline = true;
      if (reduceMotion || !autoplayEnabled) video.pause();
      video.addEventListener('play', updateToggle);
      video.addEventListener('pause', updateToggle);
      video.addEventListener('ended', updateToggle);
      updateToggle();
    }

    if (video && toggle) {
      toggle.addEventListener('click', () => {
        if (video.paused) {
          shouldResume = true;
          playVideo();
        } else {
          shouldResume = false;
          video.pause();
        }
      });
    }

    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      if (video && shouldResume) playVideo();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            root.classList.add('is-visible');
            if (video && shouldResume) playVideo();
          } else if (video) {
            video.pause();
          }
        });
      },
      { rootMargin: '80px 0px -8% 0px', threshold: 0.16 }
    );

    observer.observe(root);
    controllers.set(root, observer);
  };

  const destroy = (root) => {
    const observer = controllers.get(root);
    if (observer) observer.disconnect();
    controllers.delete(root);
    const video = root.querySelector('[data-rr-workshop-proof-video]');
    if (video) video.pause();
  };

  const initAll = (scope = document) => getRoots(scope).forEach(init);

  window.RRWorkshopProof = { initAll, destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => getRoots(event.target).forEach(destroy));
  document.addEventListener('shopify:section:select', (event) => {
    getRoots(event.target).forEach((root) => root.classList.add('is-visible'));
  });
})();
